{
  "$id": "wealthlane://forms/participant/rules",
  "definitions": {
    "zipLookup": {
      "debounceMs": 500,
      "condition": {
        "allOf": [
          {
            "field": "{{countryFlag}}",
            "notEquals": true
          },
          {
            "field": "{{zipField}}",
            "matches": "^\\d{5}$"
          }
        ]
      },
      "lookup": {
        "actionId": "ZIP_LOOKUP",
        "params": {
          "zipCode": "{{zipField}}"
        },
        "cache": "dedupe-session",
        "rejectIfTouched": true
      },
      "mapTo": {
        "city": "{{cityField}}",
        "state": "{{stateTextField}}",
        "stateId": "{{stateIdField}}"
      }
    },
    "addressCountryClear": {
      "clear": [
        "{{zipField}}",
        "{{stateIdField}}",
        "{{stateTextField}}",
        "{{cityField}}"
      ]
    },
    "ssnAutoFormat": {
      "condition": {
        "field": "#/properties/participantOtherCountry",
        "notEquals": true
      },
      "format": {
        "fn": "SSN_US",
        "description": "Strips non-digits, inserts dashes: NNN-NN-NNNN"
      }
    },
    "phoneAutoFormat": {
      "condition": {
        "field": "#/properties/isOtherCountryPhone",
        "notEquals": true
      },
      "format": {
        "fn": "PHONE_US",
        "description": "Strips non-digits, formats XXX-XXX-XXXX"
      }
    }
  },
  "effects": [
    {
      "id": "phoneCountryCodeChange",
      "watch": "#/properties/workNumberCountryCodeId",
      "clear": [
        "#/properties/workNumber"
      ],
      "set": {
        "#/properties/isOtherCountryPhone": {
          "operator": "optionProp",
          "field": "#/properties/workNumberCountryCodeId",
          "prop": "isOtherCountry"
        }
      }
    },
    {
      "id": "citizenshipCountryChange",
      "watch": "#/properties/countryId",
      "clear": [
        "#/properties/ssn"
      ],
      "set": {
        "#/properties/participantOtherCountry": {
          "operator": "optionProp",
          "field": "#/properties/countryId",
          "prop": "isOtherCountry"
        }
      }
    },
    {
      "$ref": "#/definitions/ssnAutoFormat",
      "id": "ssnAutoFormat",
      "watch": "#/properties/ssn",
      "bind": {}
    },
    {
      "$ref": "#/definitions/phoneAutoFormat",
      "id": "phoneAutoFormat",
      "watch": "#/properties/workNumber",
      "bind": {}
    },
    {
      "id": "residentStatusLabelSync",
      "watch": "#/properties/residentStatusId",
      "set": {
        "#/properties/residentStatusName": {
          "operator": "optionProp",
          "field": "#/properties/residentStatusId",
          "prop": "label"
        }
      }
    },
    {
      "$ref": "#/definitions/addressCountryClear",
      "id": "employmentCountryChange",
      "watch": "#/properties/employmentCountryId",
      "bind": {
        "zipField": "#/properties/employmentZipCode",
        "stateIdField": "#/properties/employmentStateId",
        "stateTextField": "#/properties/employmentStateText",
        "cityField": "#/properties/employmentCityText"
      },
      "set": {
        "#/properties/isOtherCountry": {
          "operator": "optionProp",
          "field": "#/properties/employmentCountryId",
          "prop": "isOtherCountry"
        }
      }
    },
    {
      "$ref": "#/definitions/addressCountryClear",
      "id": "homeCountryChange",
      "watch": "#/properties/homeCountryId",
      "bind": {
        "zipField": "#/properties/homeZipCode",
        "stateIdField": "#/properties/homeStateId",
        "stateTextField": "#/properties/homeStateText",
        "cityField": "#/properties/homeCityText"
      },
      "set": {
        "#/properties/isHomeOtherCountry": {
          "operator": "optionProp",
          "field": "#/properties/homeCountryId",
          "prop": "isOtherCountry"
        }
      }
    },
    {
      "$ref": "#/definitions/addressCountryClear",
      "id": "mailingCountryChange",
      "watch": "#/properties/mailingCountryId",
      "bind": {
        "zipField": "#/properties/mailingZipCode",
        "stateIdField": "#/properties/mailingStateId",
        "stateTextField": "#/properties/mailingStateText",
        "cityField": "#/properties/mailingCityText"
      },
      "set": {
        "#/properties/isMailingOtherCountry": {
          "operator": "optionProp",
          "field": "#/properties/mailingCountryId",
          "prop": "isOtherCountry"
        }
      }
    },
    {
      "id": "mailingToggleOff",
      "watch": "#/properties/isMailingAddressDifferent",
      "condition": {
        "field": "#/properties/isMailingAddressDifferent",
        "equals": false
      },
      "clear": [
        "#/properties/mailingAddressLine1",
        "#/properties/mailingAddressLine2",
        "#/properties/mailingCountryId",
        "#/properties/mailingZipCode",
        "#/properties/mailingStateId",
        "#/properties/mailingStateText",
        "#/properties/mailingCityText",
        "#/properties/isMailingOtherCountry"
      ]
    },
    {
      "id": "transferAgentLabelSync",
      "watch": "#/properties/transferAgentCompanyId",
      "set": {
        "#/properties/taName": {
          "operator": "optionProp",
          "field": "#/properties/transferAgentCompanyId",
          "prop": "label"
        }
      }
    },
    {
      "id": "employmentStateClearCity",
      "watch": "#/properties/employmentStateId",
      "condition": {
        "not": {
          "field": "#/properties/employmentZipCode",
          "matches": "^\\d{5}$"
        }
      },
      "clear": [
        "#/properties/employmentCityText"
      ]
    },
    {
      "id": "homeStateClearCity",
      "watch": "#/properties/homeStateId",
      "condition": {
        "not": {
          "field": "#/properties/homeZipCode",
          "matches": "^\\d{5}$"
        }
      },
      "clear": [
        "#/properties/homeCityText"
      ]
    },
    {
      "id": "mailingStateClearCity",
      "watch": "#/properties/mailingStateId",
      "condition": {
        "not": {
          "field": "#/properties/mailingZipCode",
          "matches": "^\\d{5}$"
        }
      },
      "clear": [
        "#/properties/mailingCityText"
      ]
    },
    {
      "$ref": "shared://rules/settlement#templates/defaultSettlementMethodCascade",
      "id": "defaultSettlementMethodCascade",
      "bind": {
        "prefix": "#/properties/settlementConfiguration"
      }
    }
  ],
  "observers": [
    {
      "$ref": "#/definitions/zipLookup",
      "id": "zipLookupEmployment",
      "watch": "#/properties/employmentZipCode",
      "bind": {
        "countryFlag": "#/properties/isOtherCountry",
        "zipField": "#/properties/employmentZipCode",
        "cityField": "#/properties/employmentCityText",
        "stateTextField": "#/properties/employmentStateText",
        "stateIdField": "#/properties/employmentStateId"
      }
    },
    {
      "$ref": "#/definitions/zipLookup",
      "id": "zipLookupHome",
      "watch": "#/properties/homeZipCode",
      "bind": {
        "countryFlag": "#/properties/isHomeOtherCountry",
        "zipField": "#/properties/homeZipCode",
        "cityField": "#/properties/homeCityText",
        "stateTextField": "#/properties/homeStateText",
        "stateIdField": "#/properties/homeStateId"
      }
    },
    {
      "$ref": "#/definitions/zipLookup",
      "id": "zipLookupMailing",
      "watch": "#/properties/mailingZipCode",
      "bind": {
        "countryFlag": "#/properties/isMailingOtherCountry",
        "zipField": "#/properties/mailingZipCode",
        "cityField": "#/properties/mailingCityText",
        "stateTextField": "#/properties/mailingStateText",
        "stateIdField": "#/properties/mailingStateId"
      }
    }
  ],
  "rules": [
    {
      "id": "rule_employmentZip_digits",
      "target": "#/properties/employmentZipCode",
      "rule": "pattern",
      "condition": {
        "allOf": [
          {
            "field": "#/properties/employmentZipCode",
            "notEmpty": true
          },
          {
            "field": "#/properties/isOtherCountry",
            "notEquals": true
          }
        ]
      },
      "patternPreset": "ZIP_US_DIGITS",
      "message": "Must be only digits"
    },
    {
      "id": "rule_employmentZip_length",
      "target": "#/properties/employmentZipCode",
      "rule": "pattern",
      "condition": {
        "allOf": [
          {
            "field": "#/properties/employmentZipCode",
            "notEmpty": true
          },
          {
            "field": "#/properties/isOtherCountry",
            "notEquals": true
          }
        ]
      },
      "patternPreset": "ZIP_US",
      "message": "Must be 5 digits"
    },
    {
      "id": "rule_ssn_us_pattern",
      "target": "#/properties/ssn",
      "rule": "pattern",
      "condition": {
        "allOf": [
          {
            "field": "#/properties/participantOtherCountry",
            "notEquals": true
          },
          {
            "field": "#/properties/ssn",
            "notEmpty": true
          }
        ]
      },
      "patternPreset": "SSN_FORMAT",
      "message": "Must be 9 digits"
    },
    {
      "id": "rule_ssn_min_length",
      "target": "#/properties/ssn",
      "rule": "minLength",
      "condition": {
        "field": "#/properties/participantOtherCountry",
        "notEquals": true
      },
      "minValue": 11,
      "message": "Must be 9 digits"
    },
    {
      "id": "rule_ssn_max_length",
      "target": "#/properties/ssn",
      "rule": "maxLength",
      "condition": {
        "field": "#/properties/participantOtherCountry",
        "notEquals": true
      },
      "maxValue": 11,
      "message": "Must be 9 digits"
    },
    {
      "id": "rule_work_number_us_pattern",
      "target": "#/properties/workNumber",
      "rule": "pattern",
      "condition": {
        "allOf": [
          {
            "field": "#/properties/isOtherCountryPhone",
            "notEquals": true
          },
          {
            "field": "#/properties/workNumber",
            "notEmpty": true
          }
        ]
      },
      "patternPreset": "PHONE_US",
      "message": "Must be 10 digits"
    },
    {
      "id": "rule_work_number_non_us_digits",
      "target": "#/properties/workNumber",
      "rule": "pattern",
      "condition": {
        "allOf": [
          {
            "field": "#/properties/isOtherCountryPhone",
            "equals": true
          },
          {
            "field": "#/properties/workNumber",
            "notEmpty": true
          }
        ]
      },
      "patternPreset": "NUMERIC_PHONE",
      "message": "Must be only digits"
    },
    {
      "id": "rule_ta_name_required",
      "target": "#/properties/transferAgentCompanyId",
      "rule": "required",
      "condition": {
        "field": "#/properties/taAccountNumber",
        "notEmpty": true
      },
      "message": "Required field"
    },
    {
      "id": "rule_ta_account_required",
      "target": "#/properties/taAccountNumber",
      "rule": "required",
      "condition": {
        "field": "#/properties/transferAgentCompanyId",
        "notEmpty": true
      },
      "message": "Required field"
    },
    {
      "id": "rule_employee_id_immutable",
      "target": "#/properties/employeeId",
      "rule": "readOnly",
      "mode": "edit",
      "message": "Employee ID cannot be changed after creation"
    },
    {
      "id": "rule_email_immutable",
      "target": "#/properties/email",
      "rule": "readOnly",
      "mode": "edit",
      "message": "Email cannot be changed after creation"
    },
    {
      "$ref": "shared://rules/settlement#templates/settlementWindowStart_greaterThanZero",
      "id": "rule_settlementWindowStart_greaterThanZero",
      "bind": {
        "prefix": "#/properties/settlementConfiguration"
      }
    },
    {
      "$ref": "shared://rules/settlement#templates/settlementWindowEnd_greaterThanZero",
      "id": "rule_settlementWindowEnd_greaterThanZero",
      "bind": {
        "prefix": "#/properties/settlementConfiguration"
      }
    },
    {
      "$ref": "shared://rules/settlement#templates/settlementWindowEnd_lessThanStart",
      "id": "rule_settlementWindowEnd_lessThanStart",
      "bind": {
        "prefix": "#/properties/settlementConfiguration"
      }
    },
    {
      "$ref": "shared://rules/settlement#templates/settlementWindowStart_requiredWhenEndFilled",
      "id": "rule_settlementWindowStart_requiredWhenEndFilled",
      "bind": {
        "prefix": "#/properties/settlementConfiguration"
      }
    },
    {
      "$ref": "shared://rules/settlement#templates/settlementWindowEnd_requiredWhenStartFilled",
      "id": "rule_settlementWindowEnd_requiredWhenStartFilled",
      "bind": {
        "prefix": "#/properties/settlementConfiguration"
      }
    },
    {
      "$ref": "shared://rules/settlement#templates/settlementMethods_minOne",
      "id": "rule_settlementMethods_minOne",
      "bind": {
        "prefix": "#/properties/settlementConfiguration"
      }
    },
    {
      "$ref": "shared://rules/settlement#templates/settlementDefaultTypeId_requiredWhenMethodsSelected",
      "id": "rule_settlementDefaultTypeId_requiredWhenMethodsSelected",
      "bind": {
        "prefix": "#/properties/settlementConfiguration"
      }
    },
    {
      "id": "rule_homeZip_digits",
      "target": "#/properties/homeZipCode",
      "rule": "pattern",
      "condition": {
        "allOf": [
          {
            "field": "#/properties/homeZipCode",
            "notEmpty": true
          },
          {
            "field": "#/properties/isHomeOtherCountry",
            "notEquals": true
          }
        ]
      },
      "patternPreset": "ZIP_US_DIGITS",
      "message": "Must be only digits"
    },
    {
      "id": "rule_homeZip_length",
      "target": "#/properties/homeZipCode",
      "rule": "pattern",
      "condition": {
        "allOf": [
          {
            "field": "#/properties/homeZipCode",
            "notEmpty": true
          },
          {
            "field": "#/properties/isHomeOtherCountry",
            "notEquals": true
          }
        ]
      },
      "patternPreset": "ZIP_US",
      "message": "Must be 5 digits"
    },
    {
      "id": "rule_mailingZip_digits",
      "target": "#/properties/mailingZipCode",
      "rule": "pattern",
      "condition": {
        "allOf": [
          {
            "field": "#/properties/isMailingAddressDifferent",
            "equals": true
          },
          {
            "field": "#/properties/mailingZipCode",
            "notEmpty": true
          },
          {
            "field": "#/properties/isMailingOtherCountry",
            "notEquals": true
          }
        ]
      },
      "patternPreset": "ZIP_US_DIGITS",
      "message": "Must be only digits"
    },
    {
      "id": "rule_mailingZip_length",
      "target": "#/properties/mailingZipCode",
      "rule": "pattern",
      "condition": {
        "allOf": [
          {
            "field": "#/properties/isMailingAddressDifferent",
            "equals": true
          },
          {
            "field": "#/properties/mailingZipCode",
            "notEmpty": true
          },
          {
            "field": "#/properties/isMailingOtherCountry",
            "notEquals": true
          }
        ]
      },
      "patternPreset": "ZIP_US",
      "message": "Must be 5 digits"
    }
  ]
}
